function getTitle(vm, route) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function' ? title.call(vm, route) : title
  }
}

const serverTitleMixin = {
  created() {
    const title = getTitle(this, this.$route)
    if (title) {
      this.$ssrContext.title = title
    }
  }
}

const clientTitleMixin = {
  beforeRouteUpdate(to, from, next) {
    const title = getTitle(this, to)
    if (title) {
      document.title = title
    }
    next()
  },
  mounted() {
    const title = getTitle(this, this.$route)
    if (title) {
      document.title = title
    }
  }
}

export default process.env.VUE_ENV === 'server' ? serverTitleMixin : clientTitleMixin



// WEBPACK FOOTER //
// ./src/util/title.js